<template>
    <div class="terms-root">
        <a
            class="mute"
            href="https://highered.global/terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('shared.termsAndConds.termsAndConditions') }}
        </a>

        <a
            class="mute"
            href="https://highered.global/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('shared.termsAndConds.privacyPolicy') }}
        </a>

        <a
            class="mute"
            href="https://www.trustpilot.com/review/gethighered.global"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('shared.termsAndConds.enjoyingHighered') }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'TermsAndConds',
};
</script>

<style lang="scss" scoped>
div.terms-root {
    display: flex;
    justify-content: space-between;
    margin-inline: 6px;

    a {
        font-size: 12px;
    }
}
</style>
